import { render } from "./Profile.vue?vue&type=template&id=4b9bd660"
import script from "./Profile.vue?vue&type=script&lang=ts"
export * from "./Profile.vue?vue&type=script&lang=ts"
script.render = render

export default script